import { useUpdatePatientInfoCache } from './use-update-patient-info-cache';

import type { RpmStatuses } from 'infrastructure/enums';

interface ISocketData {
  status: RpmStatuses;
}

interface Props {
  patientGuid: string;
}

export const useQueryUpdatePatientStatus = ({ patientGuid }: Props) => {
  const { updateCache } = useUpdatePatientInfoCache();

  const updateQueryPatientStatus = (socketData: ISocketData) => {
    updateCache(patientGuid, { status: socketData.status });
  };

  return { updateQueryPatientStatus };
};
